export const MODAL_TYPE_SHARE_LINK = 'share-link';
